import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';

import Form from 'components/Form';
import InputField from 'components/InputField';

class NewMdnActivationForm extends Component {
  state = {};

  render() {
    const { saveStatus, activationResponse: activation } = this.props;
    const { areaCodeError } = this.state;

    if (saveStatus === 'SUCCEEDED') {
      return (
        <div>
          <p>Success: {String(activation.success)}</p>
          <p>PIN: {activation.pin}</p>
          <p>Details:</p>
          <pre>{JSON.stringify(activation.details, null, 2)}</pre>
        </div>
      );
    }

    return (
      <Form {...this.props} submit={'Activate Subscription'}>
        <Field component={InputField} name="pin" />
        <Field component={InputField} name="npa" label="NPA" />
        {areaCodeError && (
          <div className="text-danger mar-t mar-b">{areaCodeError}</div>
        )}
      </Form>
    );
  }
}

export default reduxForm({
  form: 'activateNewMdnSub',
})(NewMdnActivationForm);
